import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// FIREBASE TEMPORARILY DISABLED - Configuration issues
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "unii-club-email-auth.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "unii-club-email-auth",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "unii-club-email-auth.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || ""
};

// Initialize Firebase - COMMENTED OUT
// const app = initializeApp(firebaseConfig);
const app = null as any; // Placeholder

// Initialize Firebase Authentication and get a reference to the service - COMMENTED OUT
// export const auth = getAuth(app);
export const auth = null as any; // Placeholder

export default app;
